var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41176 12C1.41176 8.64794 2.60716 6.01485 4.49909 4.21767C6.39663 2.41518 9.03942 1.41176 12 1.41176C12.3898 1.41176 12.7059 1.09573 12.7059 0.705882C12.7059 0.316034 12.3898 0 12 0C8.72058 0 5.71631 1.11424 3.52679 3.1941C1.33167 5.27927 0 8.29324 0 12C0 15.7068 1.33167 18.7207 3.52679 20.8059C5.71631 22.8858 8.72058 24 12 24C12.3898 24 12.7059 23.684 12.7059 23.2941C12.7059 22.9043 12.3898 22.5882 12 22.5882C9.03942 22.5882 6.39663 21.5848 4.49909 19.7823C2.60716 17.9852 1.41176 15.3521 1.41176 12ZM19.5207 7.97152C19.7963 7.69586 20.2433 7.69586 20.5189 7.97152L24.133 11.5856C24.4087 11.8613 24.4087 12.3082 24.133 12.5839L20.5189 16.198C20.2433 16.4737 19.7963 16.4737 19.5207 16.198C19.245 15.9224 19.245 15.4754 19.5207 15.1998L21.9304 12.79H9.17647C8.78662 12.79 8.47059 12.4739 8.47059 12.0841C8.47059 11.6943 8.78662 11.3782 9.17647 11.3782H21.9291L19.5207 8.96979C19.245 8.69413 19.245 8.24719 19.5207 7.97152Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e08d1ec118dbfe226b29465a2d6e516f.svg";
export { ForwardRef as ReactComponent };